import { render, staticRenderFns } from "./ShopRegisterSet.vue?vue&type=template&id=5a0d665e&scoped=true&"
import script from "./ShopRegisterSet.vue?vue&type=script&lang=js&"
export * from "./ShopRegisterSet.vue?vue&type=script&lang=js&"
import style0 from "./ShopRegisterSet.vue?vue&type=style&index=0&id=5a0d665e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0d665e",
  null
  
)

export default component.exports